<template>
  <div class="whatsapp-otp-container">
    <div v-if="!otp" class="otp-request">
      <p class="description">Para usar ChatPTS desde WhatsApp, necesitas asociar tu número de teléfono.</p>
      <button 
        class="get-otp-button" 
        @click="getOTP" 
        :disabled="loading"
      >
        <ion-icon v-if="loading" name="time-outline" class="loading-icon"></ion-icon>
        <ion-icon v-else name="logo-whatsapp"></ion-icon>
        {{ loading ? 'Generando código...' : 'Obtener código para WhatsApp' }}
      </button>
    </div>

    <div v-if="otp" class="otp-display">
      <div class="otp-code">
        {{ otp.otp }}
      </div>
      <div class="otp-instructions">
        <h4>Instrucciones:</h4>
        <ol>
          <li>Abre WhatsApp y busca el contacto <strong>ChatPTS</strong></li>
          <li>Envía el código que se muestra arriba</li>
          <li>¡Listo! Ahora podrás usar ChatPTS desde WhatsApp</li>
        </ol>
        <p class="otp-expiry">
          Este código expira el {{ formatDate(otp.valid_until) }}
        </p>
      </div>
      <button class="generate-new-button" @click="generateNewOTP">
        Generar nuevo código
      </button>
    </div>

    <div v-if="error" class="error-message">
      {{ error }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { COUNTRY } from '../utils/countryConfig';

axios.defaults.withCredentials = true;

export default {
  name: 'WhatsAppOTPComponent',
  data() {
    return {
      otp: null,
      loading: false,
      error: null
    };
  },
  methods: {
    async getOTP() {
      try {
        this.loading = true;
        this.error = null;
        
        const response = await axios.get(process.env.VUE_APP_BASE_URL + '/api/v2/whatsapp/get-otp', {
          params: {
            country: COUNTRY
          },
          withCredentials: true
        });
        
        this.otp = response.data;
        
      } catch (error) {
        console.error('Error al obtener OTP de WhatsApp:', error);
        this.error = 'Error al generar el código. Por favor, intenta nuevamente.';
      } finally {
        this.loading = false;
      }
    },
    async generateNewOTP() {
      this.otp = null;
      await this.getOTP();
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(date);
    }
  }
};
</script>

<style scoped>
.whatsapp-otp-container {
  width: 100%;
}

.otp-request {
  text-align: center;
}

.description {
  margin-bottom: 20px;
  color: #333333;
  font-size: 14px;
  line-height: 1.5;
}

.get-otp-button {
  background-color: #25D366;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0 auto;
  min-width: 200px;
}

.get-otp-button:hover:not(:disabled) {
  background-color: #128C7E;
}

.get-otp-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.otp-display {
  text-align: center;
}

.otp-code {
  font-size: 48px;
  font-weight: bold;
  color: #25D366;
  background-color: rgba(37, 211, 102, 0.1);
  border: 2px solid #25D366;
  border-radius: 8px;
  padding: 20px;
  letter-spacing: 4px;
  margin-bottom: 20px;
  font-family: 'Courier New', monospace;
}

.otp-instructions {
  text-align: left;
  background-color: rgba(250, 250, 250, 0.9);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  border-left: 4px solid #25D366;
}

.otp-instructions h4 {
  margin: 0 0 15px 0;
  color: #333333;
  font-size: 16px;
}

.otp-instructions ol {
  margin: 0 0 15px 0;
  padding-left: 20px;
}

.otp-instructions li {
  margin-bottom: 8px;
  color: #333333;
  line-height: 1.5;
}

.otp-expiry {
  font-size: 12px;
  color: #666666;
  font-style: italic;
  margin: 0;
  text-align: center;
}

.generate-new-button {
  background-color: transparent;
  color: #25D366;
  border: 1px solid #25D366;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.generate-new-button:hover {
  background-color: #25D366;
  color: white;
}

.error-message {
  background-color: rgba(220, 53, 69, 0.1);
  border: 1px solid #dc3545;
  color: #dc3545;
  padding: 12px;
  border-radius: 4px;
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
}
</style>
